import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import LogbookAppIntegrations from '../../LogbookAppIntegration/LogbookAppIntegrations';
import getLocale from '../../../i18n/getLocale';


class FlightReportApprovalsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      logbook_app: this.props.logbook_app,
      type: false,
      modal: false,
      modal_captain_login: false,
      flight_report_id: null,
      reproved_id: null,
      reason: null,
      username: null,
      password: null,
      flight_report: this.props.flight_report,
      flight_report_approvals: this.props.flight_report_approvals,
      flight_report_reopen_warnings: this.props.flight_report_reopen_warnings,
    };

    this.reopen = this.reopen.bind(this);
    this.approve = this.approve.bind(this);
    this.reprove = this.reprove.bind(this);
    this.login = this.login.bind(this);
    
    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.flight_report_approvals) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        logbook_app: newProps.logbook_app,
        flight_report_id: newProps.flight_report_id,
        flight_report_approvals: newProps.flight_report_approvals,
        flight_report_reopen_warnings: newProps.flight_report_reopen_warnings,
        flight_report: newProps.flight_report,
        loaded: 1,
      });
    }
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  login(event) {
    var self = this;
    event.preventDefault();
    if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        username: this.state.username,
        password: this.state.password,
        flight_report_approval_id: this.state.flight_report_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/sub_commander_approval/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({modal_captain_login: false});
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  reopen(flight_report_id) {
    var self = this;
    if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.reabrirRelatorio)) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        flight_report_id: flight_report_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approve(flight_report_approval_id, type) {
    var self = this;
    if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        flight_report_approval_id: flight_report_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/' + type + '/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if(responseJson.status === 'success'){

            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          } else {
            self.setState({modal_captain_login: true, flight_report_approval_id: flight_report_approval_id});
            self.props.handleAlert('', '', 'closed');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  reprove(event) {
    event.preventDefault();
    var self = this;
    if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.reprovarRelatorio)) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        flight_report_approval_id: self.state.reproved_id,
        reason: self.state.reason,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/' + self.state.type + '/relatorio/voo/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({reason: null, reproved_id: null, modal: false});
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {
    (this.state.flight_report_reopen_warnings.length > 0) ?
    <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
      <strong>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.relatorioReabertoGerouImplicacoes}:</strong>
    </div>
   : ''
  }
  {
    (this.state.flight_report_reopen_warnings.length > 0) ?
    <div className="table-responsive">
      <table className="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaImplicacoes.Mensagem}</th>
            <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaImplicacoes.Data}</th>
          </tr>
        </thead>
        <tbody>
        {Object.keys(self.state.flight_report_reopen_warnings).map(function(k) {
          var srl = self.state.flight_report_reopen_warnings[k];
          return (
            <tr>
              <td className={"box-alert box-alert-red"} dangerouslySetInnerHTML={{__html: srl.text}}></td>
              <td className={"box-alert box-alert-red"}>{srl.created_at_str}</td>
            </tr>
          );
        })}
        </tbody>
      </table>
    </div>
   : ''
  }
  <hr/>
  <h3 className="page-title pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloAprovacoes}</h3>
  <div className="grid-buttons pull-right">
    {
      (this.state.flight_report.status_reopen === 1) ? <button onClick={() => this.reopen(this.state.flight_report.id)} className="btn btn-danger"><i className="fa fa-fw fa-close"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoReabrirRelatorio}</button> : ''
    }
    {
      (this.state.flight_report.status === 4) ? <button onClick={() => this.reopen(this.state.flight_report.id)} className="btn btn-danger"><i className="fa fa-fw fa-close"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoReabrirRelatorio}</button> : ''
    }
  </div>
  <div className="clearfix"></div>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Tipo}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Tripulante}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Aprovacao}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Acoes}</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_approvals).map(function(k) {
        var sra = self.state.flight_report_approvals[k];
        return (
          <tr>
            <td>{sra.type_str}</td>
            <td>{sra.staff_name}</td>
            <td>{sra.user_name}</td>
            <td className="text-center">
              {
                (sra.status === 0) ?
                  <div className="btn-group">
                    {
                      (sra.type == 'commander_approval' && self.state.logbook_app == 1) &&
                      <LogbookAppIntegrations
                        flight_report_id={self.state.flight_report_id}
                        flight_report_approval_id={sra.id}
                        renderButton={true}
                        popover={self.props.popover}
                        buttonClass="btn btn-info btn-sm button-inline"
                        modal_captain_login={true}
                        integrationType="approve"
                        updateData={self.props.updateData}
                      />
                    }
                    {
                      (sra.type !== 'commander_approval' || self.state.logbook_app !== 1) &&
                      <button onClick={() => {self.approve(sra.id, sra.type)}} className="btn btn-success btn-sm button-inline"><i className="fa fa-check"></i></button>
                    }
                    {
                      (sra.type !== 'reopen_approval' && sra.type !== 'commercial_approval') ?
                      <button onClick={() => {self.setState({reproved_id: sra.id, modal: true, type: sra.type})}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-close"></i></button>
                       : ''
                    }
                  </div>
                : (sra.status === 1) ?
                  <div>
                    <button className="btn btn-success btn-sm" disabled><i className="fa fa-check"></i></button>
                  </div>
                :
                  <div>
                    <button className="btn btn-danger btn-sm" disabled><i className="fa fa-close"></i></button>
                  </div>

              }
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloJustificativaReprovacao}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.reprove}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioReprovacao.RazaoDaReprovacao}:</label>
            <input type="text" name="reason" className="form-control" placeholder="" value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} />
          </div>
          <div className="col-md-6 form-group">
            <button type="submit" className="btn btn-danger btn-block btn-inline"><i className="fa fa-fw fa-close"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioReprovacao.botaoReprovarRelatorio}</button>
          </div>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_captain_login: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_captain_login} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloLoginDoComandanteNoLDAP}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_captain_login: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.login}>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-at"></i></div>
            <input type="text" name="username" className="form-control" placeholder={this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioLogin.placeholder.Email} value={this.state.username} onChange={this.handleChange.bind(this, 'username')} />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
            <input type="password" name="password" className="form-control" placeholder={this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioLogin.placeholder.Senha} value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
          </div>
        </div>
        <button className="btn btn-success btn-block" type="submit"><i className="fa fa-fw fa-sign-in"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioLogin.botaoAcessarSistema}</button>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_captain_login: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportApprovalsTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportApprovalsTab.js